import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const Breadcrumb = () => {

  const { title, breadcrumbItems } = useSelector((state) => state.breadcrumb);

  const itemLength = breadcrumbItems.length || 1;

  return (
    <div className="page-title-box">
      <h4>{title}</h4>
      <ol className="breadcrumb m-0">
        {breadcrumbItems.map((item, key) =>
          (key + 1) === itemLength ? (
            <li key={key} className="breadcrumb-item active">
              {item.title}
            </li>
          ) : (
            <li key={key} className="breadcrumb-item">
              <Link to={item.link}>{item.title}</Link>
            </li>
          )
        )}
      </ol>
    </div>
  );
};

export default Breadcrumb;
